<div class="text-center spinner-wrapper">
  <div>
    <h6 class="m-0 pb-1" *ngIf="title != null && title != undefined">
      {{ title }}
    </h6>
    <mat-spinner class="mat-spinner-color" [style.margin]="'auto'" ></mat-spinner><br />
    <img width="100px" src="assets/images/sortlogo/thm-full-logo.svg" alt="" />
  </div>
</div>
